import React from 'react';

import { OptInAddressData } from 'features/free-samples/services/types';
import {
  RenderTextField,
  RenderTextFieldProps,
} from 'shared/components/RenderTextField/RenderTextField';

export const AddressField = (
  props: Omit<RenderTextFieldProps<OptInAddressData>, 'name'> & {
    name: keyof OptInAddressData;
  },
) => <RenderTextField<OptInAddressData> {...props} />;
